module.exports = __webpack_public_path__ + "static/img/PrestationFemme2.49d28bb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PrestationFemme2.jpeg
// module id = q3BW
// module chunks = 1